"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateLogoutUrl = void 0;
const constants_1 = require("../../../constants");
/**
 * A function to generate the identity-ui logout URL
 * with a correctly formatted destination param
 * @param destination _Optional_. The relative URL to use for the destination param.
 * @returns an identity-ui logout URL with a correctly formatted destination param
 */
const generateLogoutUrl = (destination = '') => {
    const path = `${constants_1.IDENTITY_BASE_PATH}/logout`;
    if (!destination) {
        return path;
    }
    try {
        // the origin will be discarded, so we can use localhost or any other value
        const destURL = new URL(destination, 'http://localhost');
        const params = new URLSearchParams({
            destination: `${destURL.pathname}${destURL.search}`,
        });
        return `${path}?${params.toString()}`;
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error generating destination param for logout URL', err);
    }
    return path;
};
exports.generateLogoutUrl = generateLogoutUrl;
